import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

export const styles = {
  card: {
    cursor: "pointer",
    padding: "24px 20px",
    textAlign: "center",
    borderRadius: "20px",
    position: "relative",
  },
  accountsCountBox: {
    position: "absolute",
    top: -16,
    left: "50%",
    transform: "translateX(-50%)",
    width: 32,
    height: 32,
    borderRadius: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  iconButton: {
    position: "absolute",
    right: 8,
    top: 12,
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 16px",
    marginBottom: "48px",
  },
  contentBox: {
    padding: "0 16px",
  },
};

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 20,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(0),
    "& .MuiButton-root": {
      marginTop: 24,
    },
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));
